import React, { FC } from "react";
import { RouteComponentProps, Switch, Redirect } from "react-router-dom";
import { EVENT_BASE_PATH, EBIRTHDAY_CARD_PATH, EBIRTHDAY_CARD_TITLE_LIST_PATH } from "../../../constants";
import PruRoute from "../../../../../common/components/PruRoute";
import EventCategoryListPage from "./List";
import { ModulePermissionProps } from "../../../../../common/module/types";

const titlePath = `${EVENT_BASE_PATH}${EBIRTHDAY_CARD_PATH}${EBIRTHDAY_CARD_TITLE_LIST_PATH}`;

const TitlePage: FC<RouteComponentProps & ModulePermissionProps> = () => {
  return (
    <Switch>
      <Redirect exact from={titlePath} to={`${titlePath}/list`} />
      <PruRoute
        exact
        path={`${titlePath}/list`}
        render={(props) => (
          <EventCategoryListPage
            {...props}
          />
        )}
      />
    </Switch>
  )
};

export default TitlePage;